var React = require('react');

function IconmonstrArrow24OutlineLt (props) {
    return React.createElement("svg",props,[React.createElement("style",{"type":"text/css","key":0},"\n\t.st0{fill:#FFFFFF;}\n"),React.createElement("g",{"key":1},[React.createElement("polygon",{"className":"st0","points":"13.6,27.5 19.5,21.8 11.5,13.8 19.5,5.7 13.6,0 0,13.8 \t","key":0}),React.createElement("path",{"d":"M13.6,1.8l4.1,4l-8,8l8,8l-4.1,4l-11.9-12L13.6,1.8z","key":1})])]);
}

IconmonstrArrow24OutlineLt.defaultProps = {"version":"1.1","x":"0px","y":"0px","viewBox":"0 0 19.5 27.5","style":{"enableBackground":"new 0 0 19.5 27.5"},"xmlSpace":"preserve"};

module.exports = IconmonstrArrow24OutlineLt;

IconmonstrArrow24OutlineLt.default = IconmonstrArrow24OutlineLt;
